import '../../assets/styles/login.css';
import { useState } from 'react';
import { updateUser } from '../../assets/constants/global_apis';
import { useNavigate } from "react-router-dom";


export default function UpdateUserDetails({ triggerAlert }) {
  const [reqData, setReqData] = useState({});
  const navigate = useNavigate();


  const handleChange = (e) => {
    const { name, value } = e.target;
    setReqData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };


  const handleSubmit = (e) => {
    e.preventDefault();
    if(reqData.first_name.length<3) {
      triggerAlert('Error', 'First name length must be at least 3');
    }else{
      updateUser({'full_name':reqData.first_name+reqData.last_name}).then((response) => {
          triggerAlert('Success', 'Password updated successfully');
          localStorage.removeItem('init_password');
          navigate('/explorer');
      }).catch((err) => {
        triggerAlert('Error', err.message);
      });
    }
  };



  return (
    <>
    <form role="form" className="text-start"
      onSubmit={handleSubmit}
    >
      <div>
        <label>First Name</label>
        <div className="mb-3">
          <input
            type="text"
            name='first_name'
            className="form-control"
            placeholder="first name"
            aria-label="FirstName"
            value={reqData?.first_name}
            onChange={handleChange}
            required
          />
        </div>
      </div>
      <div>
        <label>Last Name</label>
        <div className="mb-3">
          <input
            type="text"
            name='last_name'
            className="form-control"
            placeholder="last name"
            aria-label="LastName"
            value={reqData?.last_name}
            onChange={handleChange}
            required
          />
        </div>
      </div>
      <div className="text-center">
        <button
          type="submit"
          className="btn bg-gradient-info w-100 mt-4 mb-0"
        >
          Save
        </button>
      </div>
    </form>
    </>
  );
}
